<template>
    <div class="singleModeTicket-message">
        <SboIcon
            name="system:warningCircle"
            size="14"
            class="singleModeTicket-messageIcon"
        />
        <span class="singleModeTicket-messageText">
            <slot />
        </span>
    </div>
</template>

<script setup lang="ts">
    import SboIcon from '@/components/common/SboIcon.vue';
</script>

<style lang="scss" scoped>
@import "@/scss/components/singleMode/ticketMessage";
</style>
